module.exports = __webpack_public_path__ + "media/word-cloud.435c3db8.webm";